var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_770_60279)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_770_60279)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_770_60279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.55957 0H16.5596V16H0.55957V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_770_60279)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_770_60279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.55957 0H16.5596V16H0.55957V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_770_60279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.55991 8C9.28511 8 9.99402 7.78495 10.597 7.38205C11.2 6.97916 11.6699 6.4065 11.9475 5.73651C12.225 5.06651 12.2976 4.32927 12.1561 3.618C12.0146 2.90674 11.6654 2.2534 11.1526 1.74061C10.6398 1.22782 9.98651 0.878599 9.27524 0.73712C8.56398 0.595641 7.82674 0.668253 7.15674 0.945774C6.48674 1.2233 5.91409 1.69326 5.51119 2.29624C5.10829 2.89922 4.89324 3.60813 4.89324 4.33333C4.89324 5.30579 5.27955 6.23842 5.96719 6.92606C6.65482 7.61369 7.58745 8 8.55991 8ZM10.0092 9.37533H7.10724C5.79059 9.37551 4.52791 9.89863 3.59689 10.8296C2.66587 11.7607 2.14275 13.0233 2.14258 14.34C2.14258 14.6033 2.24714 14.8559 2.43328 15.0422C2.61942 15.2284 2.87191 15.3332 3.13524 15.3333H13.9846C14.115 15.3335 14.2443 15.3079 14.3648 15.2581C14.4854 15.2082 14.5949 15.135 14.6871 15.0427C14.7793 14.9505 14.8524 14.8409 14.9022 14.7203C14.952 14.5997 14.9775 14.4705 14.9772 14.34C14.9772 13.6878 14.8486 13.042 14.5988 12.4394C14.3491 11.8369 13.9831 11.2895 13.5218 10.8285C13.0604 10.3674 12.5127 10.0018 11.9101 9.75247C11.3074 9.50313 10.6615 9.37498 10.0092 9.37533Z"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_770_60279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.55957)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_770_60279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.55957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9f2765d469852a576c70697f54fb1d5e.svg";
export { ForwardRef as ReactComponent };